import {
  checkIfRested,
  isCurrentlyEmployed,
} from '../shared/helpers/eligibilityChecks';
import { PoolerCustomerMap } from '../shared/helpers/PoolerMap';
import { Shift } from '../shared/models/shift';
import { PoolerUser } from '../shared/models/user';

export interface FilterPossibleUsersForJobParams {
  users: PoolerUser[];
  date: string;
  shifts: Shift[];
  poolerMap: PoolerCustomerMap;
  userCustomerId: string;
}

export function filterPossibleUsersForJob({
  users,
  date,
  shifts: jobShifts,
  poolerMap,
  userCustomerId,
}: FilterPossibleUsersForJobParams): PoolerUser[] {
  return users.filter((poolerUser: PoolerUser) => {
    const customerOfUser = poolerMap?.getCustomerOfUser(poolerUser._id);
    return (
      (poolerUser.customerInformation?.[customerOfUser?._id || userCustomerId]
        ?.enableJobs === undefined ||
        poolerUser.customerInformation?.[customerOfUser?._id || userCustomerId]
          ?.enableJobs) &&
      checkIfRested({
        user: poolerUser,
        jobDate: date,
        jobShifts: jobShifts,
        requiredPause: customerOfUser?.requiredPause
          ? customerOfUser.requiredPause
          : 1,
        blockingOnly: true,
      }).hasRested &&
      customerOfUser &&
      isCurrentlyEmployed(poolerUser, customerOfUser._id, date)
    );
  });
}
